import React from 'react';
import ErrorBoundaries from '../../../components/ErrorBoundaries';
import EinstellungenSeitenKopf from '../components';
import AllCoutrysTable from './components/AllCountrysTable';

function CoutrysPage() {
  return (
    <>
      <EinstellungenSeitenKopf title="Länder" />
      <ErrorBoundaries>
        <AllCoutrysTable />
      </ErrorBoundaries>
    </>
  );
}
export default CoutrysPage;
